@if (enabled) {
  <app-update-policy-status-modal
    [policy]="policy"
    [status]="PolicyStatus.ACTIVE"
    titleText="Réactiver cette police ?"
    i18n-titleText
    (updateSuccess)="refreshTaskDetails()"
  >
    <app-arrow-right-icon
      height="16px"
      width="16px"
      color="var(--brand-500)"
      ngbTooltip="Réactiver"
      i18n-ngbTooltip
      trigger
    />
  </app-update-policy-status-modal>
}
